/* eslint-disable max-len */
import type { FC } from 'react';

import type { BreakPatternProps } from './breakPatternTypes';

export const HeadFlippedBreak: FC<BreakPatternProps> = props => {
  const { topColor, bottomColor, shadowColor, shadowOpacity = 0.2, ...rest } = props;
  return (
    <svg
      width="1440"
      height="96"
      viewBox="0 0 1440 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      role="presentation"
      {...rest}
    >
      <defs>
        <filter id="break-headflipped-shadow" x="0" y="0" width="100%" height="96">
          <feGaussianBlur stdDeviation="15" />
          <feComposite operator="out" in2="SourceGraphic" />
        </filter>
      </defs>

      {/* Top section */}
      <path
        d="M1440 0.000128746L4.27734e-06 9.68134e-08C228.19 32.5249 470.07 49.9999 720.56 49.9999C971.05 50 1212.15 32.4188 1440 0.000128746Z"
        fill={topColor}
      />

      {/* Bottom section */}
      <path
        d="M1440 96V0C1212.15 32.4189 971.051 50 720.561 50C470.07 50 228.189 32.5254 0 0V96H1440Z"
        fill={bottomColor}
      />

      {/* Drop shadow (same path as the top section with the filter applied) */}
      <path
        d="M1440 0.000128746L4.27734e-06 9.68134e-08C228.19 32.5249 470.07 49.9999 720.56 49.9999C971.05 50 1212.15 32.4188 1440 0.000128746Z"
        fill={shadowColor}
        opacity={shadowOpacity}
        filter="url(#break-headflipped-shadow)"
      />
    </svg>
  );
};
